var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-form',{attrs:{"id":_vm.id.toString(),"view-type":"edit"}})}
var staticRenderFns = []

export { render, staticRenderFns }